export default "__VITE_ASSET__734405ca__"